import { getSlugValue } from 'utilities';

export const EXTERNAL_VALUATION_KEY = 'externalValuation';
export const EXTERNAL_VALUATION_LABEL = 'External Valuation';
export const EXTERNAL_VALUATION_SPREADSHEET_COLUMN_NAME = 'Column';
export const EXTERNAL_VALUATION_SPREADSHEET_COLUMN_NAME_PLURAL = 'Columns';
export const EXTERNAL_VALUATION_SPREADSHEET_TITLE = EXTERNAL_VALUATION_LABEL;
export const EXTERNAL_VALUATION_SPREADSHEET_SLUG = getSlugValue(EXTERNAL_VALUATION_SPREADSHEET_TITLE);
export const EXTERNAL_VALUATION_SPREADSHEET_TABLE = `${EXTERNAL_VALUATION_SPREADSHEET_SLUG}-table`;
